import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/hr/501/',
    component: ComponentCreator('/hr/501/', '607'),
    exact: true
  },
  {
    path: '/hr/articles/',
    component: ComponentCreator('/hr/articles/', '3df'),
    exact: true
  },
  {
    path: '/hr/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/hr/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'c50'),
    exact: true
  },
  {
    path: '/hr/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/hr/articles/2024/07/09/diskusija-lj-nj/', '495'),
    exact: true
  },
  {
    path: '/hr/articles/archive/',
    component: ComponentCreator('/hr/articles/archive/', '985'),
    exact: true
  },
  {
    path: '/hr/articles/authors/',
    component: ComponentCreator('/hr/articles/authors/', 'e63'),
    exact: true
  },
  {
    path: '/hr/search/',
    component: ComponentCreator('/hr/search/', '0d7'),
    exact: true
  },
  {
    path: '/hr/',
    component: ComponentCreator('/hr/', '4e1'),
    exact: true
  },
  {
    path: '/hr/',
    component: ComponentCreator('/hr/', '7a3'),
    routes: [
      {
        path: '/hr/',
        component: ComponentCreator('/hr/', 'd91'),
        routes: [
          {
            path: '/hr/tags/',
            component: ComponentCreator('/hr/tags/', 'ede'),
            exact: true
          },
          {
            path: '/hr/tags/comparative/',
            component: ComponentCreator('/hr/tags/comparative/', 'cdc'),
            exact: true
          },
          {
            path: '/hr/tags/gramatika/',
            component: ComponentCreator('/hr/tags/gramatika/', 'd89'),
            exact: true
          },
          {
            path: '/hr/tags/grammar/',
            component: ComponentCreator('/hr/tags/grammar/', '982'),
            exact: true
          },
          {
            path: '/hr/tags/interslavic/',
            component: ComponentCreator('/hr/tags/interslavic/', 'cfd'),
            exact: true
          },
          {
            path: '/hr/tags/language-learning/',
            component: ComponentCreator('/hr/tags/language-learning/', '136'),
            exact: true
          },
          {
            path: '/hr/tags/linguistics/',
            component: ComponentCreator('/hr/tags/linguistics/', '5cb'),
            exact: true
          },
          {
            path: '/hr/tags/meduslavenski-jezik/',
            component: ComponentCreator('/hr/tags/meduslavenski-jezik/', '509'),
            exact: true
          },
          {
            path: '/hr/tags/meduslavenski/',
            component: ComponentCreator('/hr/tags/meduslavenski/', 'e80'),
            exact: true
          },
          {
            path: '/hr/tags/personal-pronouns/',
            component: ComponentCreator('/hr/tags/personal-pronouns/', '9d4'),
            exact: true
          },
          {
            path: '/hr/tags/pronouns/',
            component: ComponentCreator('/hr/tags/pronouns/', 'bd7'),
            exact: true
          },
          {
            path: '/hr/tags/slavic-languages/',
            component: ComponentCreator('/hr/tags/slavic-languages/', '718'),
            exact: true
          },
          {
            path: '/hr/tags/ucenje-jezika/',
            component: ComponentCreator('/hr/tags/ucenje-jezika/', 'a41'),
            exact: true
          },
          {
            path: '/hr/tags/usporedba-jezika/',
            component: ComponentCreator('/hr/tags/usporedba-jezika/', '5fc'),
            exact: true
          },
          {
            path: '/hr/tags/zamjenice/',
            component: ComponentCreator('/hr/tags/zamjenice/', 'd19'),
            exact: true
          },
          {
            path: '/hr/',
            component: ComponentCreator('/hr/', '53c'),
            routes: [
              {
                path: '/hr/learn/faq/',
                component: ComponentCreator('/hr/learn/faq/', 'b9c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/',
                component: ComponentCreator('/hr/learn/grammar/', 'cdd'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/adjectives/',
                component: ComponentCreator('/hr/learn/grammar/adjectives/', 'f00'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/conjunctions/',
                component: ComponentCreator('/hr/learn/grammar/conjunctions/', '8cb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/nouns/',
                component: ComponentCreator('/hr/learn/grammar/nouns/', '0df'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/numerals/',
                component: ComponentCreator('/hr/learn/grammar/numerals/', '31d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/prepositions/',
                component: ComponentCreator('/hr/learn/grammar/prepositions/', '3c7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/pronouns/',
                component: ComponentCreator('/hr/learn/grammar/pronouns/', 'c15'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/syntax/',
                component: ComponentCreator('/hr/learn/grammar/syntax/', '58c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/verbs/',
                component: ComponentCreator('/hr/learn/grammar/verbs/', 'b46'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/introduction/',
                component: ComponentCreator('/hr/learn/introduction/', '742'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/hr/learn/misc/constructed-slavic-languages/', 'd5f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/design-criteria/',
                component: ComponentCreator('/hr/learn/misc/design-criteria/', 'f85'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/history/',
                component: ComponentCreator('/hr/learn/misc/history/', '361'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/language-comparison/',
                component: ComponentCreator('/hr/learn/misc/language-comparison/', 'd6a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/numbers-1-10/',
                component: ComponentCreator('/hr/learn/misc/numbers-1-10/', '4cb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/hr/learn/misc/pan-slavic-relay/', '16a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/personal-pronouns/',
                component: ComponentCreator('/hr/learn/misc/personal-pronouns/', '678'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/orthography/',
                component: ComponentCreator('/hr/learn/orthography/', '0a7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/phonology/',
                component: ComponentCreator('/hr/learn/phonology/', '2d1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/pronunciation/',
                component: ComponentCreator('/hr/learn/pronunciation/', '0eb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/simple-grammar/',
                component: ComponentCreator('/hr/learn/simple-grammar/', '734'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/simple-grammar/level-1/',
                component: ComponentCreator('/hr/learn/simple-grammar/level-1/', '63e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/simple-grammar/level-2/',
                component: ComponentCreator('/hr/learn/simple-grammar/level-2/', 'a93'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/vocabulary/derivation/',
                component: ComponentCreator('/hr/learn/vocabulary/derivation/', '1cf'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/hr/learn/vocabulary/flavourisation/', '130'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/vocabulary/word-formation/',
                component: ComponentCreator('/hr/learn/vocabulary/word-formation/', 'ed8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/resources/',
                component: ComponentCreator('/hr/resources/', '399'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/applets/',
                component: ComponentCreator('/hr/resources/applets/', '22e'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/applets/intelligibility/',
                component: ComponentCreator('/hr/resources/applets/intelligibility/', 'e38'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/applets/transliterator/',
                component: ComponentCreator('/hr/resources/applets/transliterator/', '632'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/keyboards/',
                component: ComponentCreator('/hr/resources/keyboards/', '7cd'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
